<span class="count-badge">{{ count() }}</span>
